import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { MateriaisService } from '../../../../providers/materiais-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { FileService } from '../../../../providers/file-service';
import { AGORA } from "../../../../app/AGORA";

import createNumberMask from 'text-mask-addons/dist/createNumberMask'

declare var jsPDF: any;

@Component({
  selector: 'page-bens-moveis',
  templateUrl: 'bens-moveis.html',
  providers: [
    AGORA,
    MateriaisService
  ]
})
export class BensMateriaisMoveisPage extends ModulosController {
  listaDados: any = [];
  loading: boolean = true;
  idSecaoPagina: string = "162";
  tiposArquivosAceitos: string = "application/xls";
  dadosImportados: any[];
  listaDeAnos: Array<number>;
  relatorioParaAdicionar: any;

  numberMask = createNumberMask({
    prefix: '',
    suffix: '', // This will put the dollar sign at the end, with a space.
    includeThousandsSeparator: false,
    thousandsSeparatorSymbol: '.',
    allowDecimal: false,
    decimalSymbol: ','
  });

  objetoEdit: any = null;
  listEdit: any = [];
  listAdicionar: any = [];

  analise: any = null;

  page1: number = 1;

  @ViewChild('inputFileCM')
  inputFileCMVar: ElementRef;

  selecionarTodosChecked = false;

  totalValorContabil = 0;
  totalDepreciacaoExercicio = 0;
  totalDepreciacaoAcumulada = 0;
  totalReducaoValorRecExercicio = 0;
  totalReducaoValorRecAcumulado = 0;

  constructor(
    public AGORA: AGORA,
    public navCtrl: NavController,
    public alertService: AlertService,
    public modalCtrl: ModalController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public materiaisService: MateriaisService,
    private fileService: FileService,
    public gestaoPcaService: GestaoPcaService,
    private menuService: MenuService) {
    super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.analise = this.navParams.get('analise');

    this.relatorioParaAdicionar = {
      "id": '',
      "item": '',
      "ano": '',
      "estadoConservacao": '',
      "codigoConta": '',
      "descricaoConta": '',
      "valorContabil": '',
      "depreciacaoExercicio": '',
      "depreciacaoAcumulada": '',
      "reducaoValorRecExercicio": '',
      "reducaoValorRecAcumulado": '',
      "idModuloAnalise": ''
    };

    this.carregarDados();
    this.setModuloId(13);

    let anoAtual = new Date().getFullYear();

    this.listaDeAnos = new Array<number>();
    this.listaDeAnos.push(anoAtual);

    for (var i = 0; i < 30; i++) {
      this.listaDeAnos.push(anoAtual -= 1);
    }

  }

  validaAnoDigitos() {

    let tamanho: number = this.relatorioParaAdicionar.ano.length;
    let anoPca: number = Number(this.gestaoPcaService.getPCA().dsAnoexercicio);
    let anoInformado: number = Number(this.relatorioParaAdicionar.ano);

    if (tamanho = 4) {
      if (anoInformado > anoPca) {
        this.relatorioParaAdicionar.ano = 0;
      }
    } else {
      this.relatorioParaAdicionar.ano = 0;
    }
  }

  carregarDados() {
    this.materiaisService.listarInventarios(this.idSecaoPagina).subscribe(data => {
      this.listaDados = data;
      this.totalizarValores();
      this.selecionarTodosChecked = false;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
    });

  }

  fileChange(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
      if (callback) {
        this.loading = true;
        this.fileService.cargaInventariosBens(event, this.idSecaoPagina, this.selecionarTodosChecked).subscribe(data => {
          this.inputFileCMVar.nativeElement.value = "";
          this.dadosImportados = data;

          for (let j = 0; j < this.dadosImportados.length; j++) {
            this.dadosImportados[j].checked = true;
            this.listaDados.push(this.dadosImportados[j]);            
          }

          this.totalizarValores();

          this.alertService.mostraAlerta("Importação concluída.","Para efetivar a importação, clique em salvar ou finalizar.");   
          // this.alertService.mostraAlerta("Importação concluída com Sucesso!", "");          
          this.loading = false;

        }, error => {
          this.inputFileCMVar.nativeElement.value = "";
          this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error.mensagem);
          this.loading = false;
        });
      } else {
        this.inputFileCMVar.nativeElement.value = "";
      }
    });
  }

  downloadDoModelo() {
    this.fileService.downloadModeloCargaGestaoMateriais(this.idSecaoPagina);
  }

  adicionarRelatorio() {
    let erros = "";
    let constReticenciasMaisPularLinhaHTML = "... <br><br>";

    // REGRAS DEPRECIACAO
    if (this.relatorioParaAdicionar.depreciacaoExercicio > this.relatorioParaAdicionar.valorContabil) {
      this.relatorioParaAdicionar.depreciacaoExercicio = 0;
      erros += "Depreciação no exercício: Valor no exercício não pode ser maior que o valor contábil." + constReticenciasMaisPularLinhaHTML;
    }

    // if (this.relatorioParaAdicionar.depreciacaoExercicio > this.relatorioParaAdicionar.depreciacaoAcumulada) {
    //   this.relatorioParaAdicionar.depreciacaoExercicio = 0;
    //   erros += "Depreciação no exercício: Valor no exercício não pode ser maior que o valor de depreciação acumulada." + constReticenciasMaisPularLinhaHTML;
    // }

    if (this.relatorioParaAdicionar.depreciacaoAcumulada > this.relatorioParaAdicionar.valorContabil) {
      this.relatorioParaAdicionar.depreciacaoAcumulada = 0;
      erros += "Depreciação acumulada: Valor da depreciação acumulada não pode ser maior que o valor contábil." + constReticenciasMaisPularLinhaHTML;
    }

    // REGRAS REDUCAO
    if (this.relatorioParaAdicionar.reducaoValorRecExercicio > this.relatorioParaAdicionar.valorContabil) {
      this.relatorioParaAdicionar.reducaoValorRecExercicio = 0;
      erros += "Redução no exercício: Valor da redução no exercício não pode ser maior que o valor contábil." + constReticenciasMaisPularLinhaHTML;
    }

    // if (this.relatorioParaAdicionar.reducaoValorRecExercicio > this.relatorioParaAdicionar.reducaoValorRecAcumulado) {
    //   this.relatorioParaAdicionar.reducaoValorRecExercicio = 0;
    //   erros += "Redução no exercício: Valor da redução no exercício não pode ser maior que o valor da redução acumulada." + constReticenciasMaisPularLinhaHTML;
    // }

    if (this.relatorioParaAdicionar.reducaoValorRecAcumulado > this.relatorioParaAdicionar.valorContabil) {
      this.relatorioParaAdicionar.reducaoValorRecAcumulado = 0;
      erros += "Redução acumulada: Valor da redução acumulada não pode ser maior que o valor contábil." + constReticenciasMaisPularLinhaHTML;
    }

    if (erros != "") {
      this.alertService.mostraAlerta("Favor verificar as questões abaixo:", erros);
    } else {
      if (this.relatorioParaAdicionar.item != '' &&
        this.relatorioParaAdicionar.ano != '' &&
        this.relatorioParaAdicionar.estadoConservacao != '' &&
        this.relatorioParaAdicionar.codigoConta != '' &&
        this.relatorioParaAdicionar.descricaoConta != '') {

        if (this.relatorioParaAdicionar.reducaoValorRecAcumulado == '' 
            || this.relatorioParaAdicionar.reducaoValorRecAcumulado == null 
            || this.relatorioParaAdicionar.reducaoValorRecAcumulado == undefined 
            || isNaN(this.relatorioParaAdicionar.reducaoValorRecAcumulado)) {
          this.relatorioParaAdicionar.reducaoValorRecAcumulado = 0;
        }

        if (this.relatorioParaAdicionar.reducaoValorRecExercicio == '' 
            || this.relatorioParaAdicionar.reducaoValorRecExercicio == null 
            || this.relatorioParaAdicionar.reducaoValorRecExercicio == undefined 
            || isNaN(this.relatorioParaAdicionar.reducaoValorRecExercicio)) {
          this.relatorioParaAdicionar.reducaoValorRecExercicio = 0;
        }

        if (this.relatorioParaAdicionar.depreciacaoAcumulada == '' 
            || this.relatorioParaAdicionar.depreciacaoAcumulada == null 
            || this.relatorioParaAdicionar.depreciacaoAcumulada == undefined 
            || isNaN(this.relatorioParaAdicionar.depreciacaoAcumulada)) {
          this.relatorioParaAdicionar.depreciacaoAcumulada = 0;
        }

        if (this.relatorioParaAdicionar.depreciacaoExercicio == '' 
          || this.relatorioParaAdicionar.depreciacaoExercicio == null 
          || this.relatorioParaAdicionar.depreciacaoExercicio == undefined 
          || isNaN(this.relatorioParaAdicionar.depreciacaoExercicio)) {
          this.relatorioParaAdicionar.depreciacaoExercicio = 0;
        }

        let relatorioNovo = {
          "id": 0,
          "item": this.relatorioParaAdicionar.item,
          "ano": this.relatorioParaAdicionar.ano,
          "estadoConservacao": this.relatorioParaAdicionar.estadoConservacao,
          "codigoConta": this.relatorioParaAdicionar.codigoConta,
          "descricaoConta": this.relatorioParaAdicionar.descricaoConta,
          "valorContabil": this.relatorioParaAdicionar.valorContabil,
          "depreciacaoExercicio": this.relatorioParaAdicionar.depreciacaoExercicio,
          "depreciacaoAcumulada": this.relatorioParaAdicionar.depreciacaoAcumulada,
          "reducaoValorRecExercicio": this.relatorioParaAdicionar.reducaoValorRecExercicio,
          "reducaoValorRecAcumulado": this.relatorioParaAdicionar.reducaoValorRecAcumulado,
          "amortizacaoExercicio": 0,
          "amortizacaoAcumulada": 0,
          "exaustaoExercicio": 0,
          "exaustaoAcumulada": 0,
          "idModuloAnalise": 0
        }

        if (this.objetoEdit) {
          let index = this.listaDados.indexOf(this.objetoEdit);
          this.listaDados.splice(index, 1);

          relatorioNovo.id = this.objetoEdit.id;

          this.listEdit.push(this.objetoEdit);
        }

        this.listaDados.push(relatorioNovo);
        this.totalizarValores();
        this.objetoEdit = null;

        this.selecionarTodosChecked = false;

        this.relatorioParaAdicionar.item = '';
        this.relatorioParaAdicionar.ano = '';
        this.relatorioParaAdicionar.estadoConservacao = '';
        this.relatorioParaAdicionar.codigoConta = '';
        this.relatorioParaAdicionar.descricaoConta = '';
        this.relatorioParaAdicionar.valorContabil = '';
        this.relatorioParaAdicionar.depreciacaoExercicio = '';
        this.relatorioParaAdicionar.depreciacaoAcumulada = '';
        this.relatorioParaAdicionar.reducaoValorRecExercicio = '';
        this.relatorioParaAdicionar.reducaoValorRecAcumulado = '';

        this.salvar(true);
      }
      else {
        this.alertService.mostraAlerta("", "Verifique os campos do formulário não preenchidos.");
        return;
      }
    }
  }

  remover(item, edit) {

    if (!edit) {
      this.alertService.mostraModalConfirmacao("Remover Item", "Deseja remover o item?", callback => {
        if (callback) {

          let index = this.listaDados.indexOf(item);
          this.listaDados.splice(index, 1);

          if (item.id != "0") {
            this.materiaisService.removerInventarios(item.id, this.idSecaoPagina).subscribe(data => {
            }, error => {
              this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro:" + error);
              this.carregarDados();
            });
          }
        }
      });
    } else {
      let index = this.listaDados.indexOf(item);

      if (item.id != "0" || item.id != undefined) {
        this.materiaisService.removerInventarios(item.id, this.idSecaoPagina).subscribe(data => {
        }, error => {
          this.alertService.mostraAlerta("", "Ocorreu um erro ao remover o registro:" + error);
          this.carregarDados();
        });
      }
    }
  }

  excluirSelecionados(){

    let qtdeSelecionados = 0; 
    this.listaDados.forEach(item => qtdeSelecionados += item.checked);
    
    if(qtdeSelecionados == 0) {
        this.alertService.mostraAlerta("", "Selecione pelo menos um registro para excluir!");
        return;
    }

    let registrosTexto = qtdeSelecionados + (qtdeSelecionados == 1 ? " registro?" : " registros?");

    this.alertService.mostraModalConfirmacao("Excluir " + registrosTexto, 
        "Deseja continuar com a exclusão de " 
            + registrosTexto + "<br/>" 
            + "Após a exclusão, os registros serão recarregados. Certifique-se de salvar possíveis alterações antes de prosseguir!", 
        callback => {            
            if (callback) {
                this.loading = true;
                                    
                let listaId = this.listaDados
                    .filter(item => item.checked)
                    .map(item => item.id);
                
                this.materiaisService.deletarInventarioLista(listaId, this.idSecaoPagina).subscribe(data => {
                    this.loading = false;
                    this.carregarDados();
                    this.alertService.mostraAlerta("", data.mensagem);
                }, error => {
                    this.loading = false;
                    this.carregarDados();
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir: " + error.mensagem);
                });
            }
        }
    );        
  }

  validaDepreciacao() {

    // REGRAS DEPRECIAÇÃO
    if (this.relatorioParaAdicionar.depreciacaoExercicio > this.relatorioParaAdicionar.valorContabil) {
      this.relatorioParaAdicionar.depreciacaoExercicio = 0;
      this.alertService.mostraAlerta("Depreciação no exercício:", "Valor no exercício não pode ser maior que o valor contábil.");
    }

    // if (this.relatorioParaAdicionar.depreciacaoExercicio > this.relatorioParaAdicionar.depreciacaoAcumulada) {
    //   this.relatorioParaAdicionar.depreciacaoExercicio = 0;
    //   this.alertService.mostraAlerta("Depreciação no exercício:", "Valor no exercício não pode ser maior que o valor de depreciação acumulada.");
    // }

    if (this.relatorioParaAdicionar.depreciacaoAcumulada > this.relatorioParaAdicionar.valorContabil) {
      this.relatorioParaAdicionar.depreciacaoAcumulada = 0;
      this.alertService.mostraAlerta("Depreciação acumulada:", "Valor da depreciação acumulada não pode ser maior que o valor contábil.");
    }

  }

  validaReducao() {

    // REGRAS REDUCAO
    if (this.relatorioParaAdicionar.reducaoValorRecExercicio > this.relatorioParaAdicionar.valorContabil) {
      this.relatorioParaAdicionar.reducaoValorRecExercicio = 0;
      this.alertService.mostraAlerta("Redução no exercício:", "Valor da redução no exercício não pode ser maior que o valor contábil.");
    }

    // if (this.relatorioParaAdicionar.reducaoValorRecExercicio > this.relatorioParaAdicionar.reducaoValorRecAcumulado) {
    //   this.relatorioParaAdicionar.reducaoValorRecExercicio = 0;
    //   this.alertService.mostraAlerta("Redução no exercício:", "Valor da redução no exercício não pode ser maior que o valor da redução acumulada.");
    // }

    if (this.relatorioParaAdicionar.reducaoValorRecAcumulado > this.relatorioParaAdicionar.valorContabil) {
      this.relatorioParaAdicionar.reducaoValorRecAcumulado = 0;
      this.alertService.mostraAlerta("Redução acumulada:", "Valor da redução acumulada não pode ser maior que o valor contábil.");
    }

  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  voltarParaMateriais() {
    this.menuService.redirecionarPagina(this.materiaisService.obterIdPaginaMateriais());
  }

  salvar(add) {
    this.loading = true;
    // this.listEdit.forEach(item => {
    //   this.remover(item, true);
    // });

    console.log(this.listaDados);
    this.listEdit = [];
    let listaVazia = [];

    this.materiaisService.salvarInventarios(this.listaDados, this.idSecaoPagina).subscribe(data => {
      if (!add) {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
      } else {
        console.log("Salvo com sucesso...");
      }

      this.carregarDados();
    }, error => {
      if (!add) {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      } else {
        console.log("Ocorreu um erro ao salvar...");
      }
      this.loading = false;
    })
  }

  salvarSelecionados(add) {
    this.loading = true;
    let listaSelecionada = this.listaDados.filter(item => item.checked);
    
    this.materiaisService.salvarInventarios(listaSelecionada, this.idSecaoPagina).subscribe(data => {
      if (!add) {
        this.alertService.mostraAlerta("", "Salvo com sucesso.");
      } else {
        console.log("Salvo com sucesso...");
      }

      this.carregarDados();
    }, error => {
      if (!add) {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
      } else {
        console.log("Ocorreu um erro ao salvar...");
      }
      this.loading = false;
    })
  
  }

  finalizar() {
    this.loading = true;

    this.listEdit.forEach(item => {
      this.remover(item, true);
    });

    this.listEdit = [];
    if (this.listaDados) {
      this.materiaisService.finalizarInventarios(this.listaDados, this.idSecaoPagina).subscribe(data => {
        this.alertService.mostraAlerta("", "Finalizado com sucesso.");
        this.loading = false;
        this.voltarParaMateriais();
      }, error => {
        this.alertService.mostraAlerta("", "Ocorreu um erro ao finalizar:" + error);
        this.loading = false;
      });
    } 
  }

  editar(item) {
    this.relatorioParaAdicionar.item = item.item;
    this.relatorioParaAdicionar.ano = item.ano;
    this.relatorioParaAdicionar.estadoConservacao = item.estadoConservacao;
    this.relatorioParaAdicionar.codigoConta = item.codigoConta;
    this.relatorioParaAdicionar.descricaoConta = item.descricaoConta;
    this.relatorioParaAdicionar.valorContabil = item.valorContabil;
    this.relatorioParaAdicionar.depreciacaoExercicio = item.depreciacaoExercicio;
    this.relatorioParaAdicionar.depreciacaoAcumulada = item.depreciacaoAcumulada;
    this.relatorioParaAdicionar.reducaoValorRecExercicio = item.reducaoValorRecExercicio;
    this.relatorioParaAdicionar.reducaoValorRecAcumulado = item.reducaoValorRecAcumulado;
    this.relatorioParaAdicionar.id = item.id;
    this.objetoEdit = item;
  }

  printData() {

    var doc = new jsPDF("l");

    var totalPagesExp = "{total_pages_count_string}";
    this.materiaisService.listarInventarios(this.idSecaoPagina).subscribe(listaCompleta => {
      var pageContent = function (data) {

        // HEADER
        doc.setFontSize(20);
        doc.setTextColor(40);
        doc.setFontStyle('normal');

        doc.text("Inventário Sintético dos Bens Móveis", data.settings.margin.left + 15, 22);

        // FOOTER
        var str = "Page " + data.pageCount;
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + " of " + totalPagesExp;
        }
        doc.setFontSize(10);
        doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
      }

      var columns = [
        { title: "Item", dataKey: "item" },
        { title: "Ano", dataKey: "ano" },
        { title: "Estado", dataKey: "estado" },
        { title: "Conta", dataKey: "conta" },
        { title: "Valor Original", dataKey: "valor" },
        { title: "Depreciação", dataKey: "dep" },
        { title: "Depreciação Acum.", dataKey: "depAcum" },
        { title: "Redução", dataKey: "red" },
        { title: "Redução Acum.", dataKey: "redAcum" }
      ];

      let rows = [];

      listaCompleta.forEach(element => {

        var item = {
          "item": element.item != null ? element.item : "",
          "ano": element.ano != null ? element.ano : "",
          "estado": element.estadoConservacao != null ? element.estadoConservacao : "",
          "conta": element.codigoConta != null ? element.codigoConta + " - " + element.descricaoConta : "",
          "valor": element.valorContabil != null ? this.formatarValorNumerico(element.valorContabil) : "",
          "dep": element.depreciacaoExercicio != null ? this.formatarValorNumerico(element.depreciacaoExercicio) : "",
          "depAcum": element.depreciacaoAcumulada != null ? this.formatarValorNumerico(element.depreciacaoAcumulada) : "",
          "red": element.reducaoValorRecExercicio != null ? this.formatarValorNumerico(element.reducaoValorRecExercicio) : "",
          "redAcum": element.reducaoValorRecAcumulado != null ? this.formatarValorNumerico(element.reducaoValorRecAcumulado) : ""
        };

        rows.push(item);
      });

      doc.autoTable(columns, rows, {
        //   theme: 'grid',
        //   addPageContent: pageContent,
        //   margin: { top: 30 },
        //   styles: {
        //       overflow: 'linebreak', // visible, hidden, ellipsize or linebreak
        //       columnWidth: 'auto'
        //   }
        // });

        theme: 'grid',
        addPageContent: pageContent,
        margin: {
          top: 30,
          left: 5
        },
        styles: {
          overflow: 'linebreak',
          columnWidth: 'wrap',
          fontSize: 10
        },
        columnStyles: {
          text: { columnWidth: 'auto' },
          item: { columnWidth: 55 },
          ano: { columnWidth: 15 },
          estado: { columnWidth: 25 },
          conta: { columnWidth: 55 },
          valor: { columnWidth: 25 },
          dep: { columnWidth: 25 },
          depAcum: { columnWidth: 25 },
          red: { columnWidth: 25 },
          redAcum: { columnWidth: 25 }
        }
      });

      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
      }

      doc.save('bens_moveis.pdf');
    });

  }

  selecionarTodos(){
    setTimeout(()=>{
        this.listaDados.forEach(
            item => item.checked = this.selecionarTodosChecked);            
    });
  }

  selecionarItem(){
      const totalItems = this.listaDados.length;
      let checked = 0;
      this.listaDados.map(obj => {
          if (obj.checked) checked++;
      });
      this.selecionarTodosChecked = checked == totalItems;
  }

  totalizarValores() {
    this.totalValorContabil = 0;
    this.totalDepreciacaoExercicio = 0;
    this.totalDepreciacaoAcumulada = 0;
    this.totalReducaoValorRecExercicio = 0;
    this.totalReducaoValorRecAcumulado = 0;

    this.listaDados.forEach(element => {
      this.totalValorContabil += element.valorContabil;
      this.totalDepreciacaoExercicio += element.depreciacaoExercicio;
      this.totalDepreciacaoAcumulada += element.depreciacaoAcumulada;
      this.totalReducaoValorRecExercicio += element.reducaoValorRecExercicio;
      this.totalReducaoValorRecAcumulado += element.reducaoValorRecAcumulado;
    });    
  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/materiais/bens-moveis/bens-moveis.ts